module.exports = __webpack_public_path__ + "img/logo.2c35ef02.png";